/* eslint-disable no-underscore-dangle */

// Filters a list of scholen based on the filters
// filters example:
// {
//   stadsdeel: 'zuid'
// }

import store from '@/store';
import {
  FilterValues, FilterKey,
} from '@/store/filter';
import { School } from '@/types';
import filterServiceExtensions from './_filterServiceExtensions';
export type FilterExtension = {
  value: string;
  handler: (schoolValue: string | null) => boolean;
};

export default {
  extensions: filterServiceExtensions,
  isFilterEqual(filter: FilterValues, filter2: FilterValues) {
    for (const key in filter) {
      const filterKey = key as FilterKey;
      if (filter[filterKey] !== filter2[filterKey]) {
        return false;
      }
    }
    return true;
  },

  filterScholen(scholen: School[], filter: FilterValues) {
    return scholen.filter((school) => {
      if (this.schoolMatchesFilter(school, filter)) {
        return true;
      }
      return false;
    });
  },

  schoolMatchesFilter(school: School, filter: FilterValues): boolean {
    // loop over every filterKey and filterValue
    // e.g. [key, filterValue] = ['stadsdeel', 'zuidoost']
    for (let [filterKey, filterValue] of Object.entries(filter)) {
      if (!filterValue) {
        continue;
      }

      // the values we use in the filters, sometimes do not directly map to
      // a property on a school - here we take care of those inconsistencies
      let schoolValueKey = filterKey as keyof School;
      if (filterKey === 'soortonderwijs') {
        schoolValueKey = 'soort_onderwijs';
      }
      if (filterKey === 'schooladvies') {
        schoolValueKey = 'soort_onderwijs';
      }

      filterKey = filterKey as FilterKey;
      let schoolValue = school[schoolValueKey] as string | undefined;

      schoolValue = typeof schoolValue === "string" ? schoolValue?.toLowerCase() : schoolValue;
      filterValue = typeof filterValue === "string" ? filterValue?.toLowerCase() : filterValue;

      // by default the filters are just compared to the schoolValue. BUT
      // certain filters have 'extensions': extra rules on how to compare them
      // to a school. Here we check if there is a filter extension for the
      // current filter key and filter value combination
      if (filterKey in this.extensions) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const extension = (this.extensions as any)[filterKey]
          .find((e: FilterExtension) => e.value?.toLowerCase() === filterValue);

        if (extension && extension.handler) {
          // Check if the extension handler needs additional data
          let extensionData = null;

          if (extension?.wantsData === true) {
            extensionData = store.getters['filter/getData'](filterKey as string);

            // If there is no data, and the extension wants data, the extension
            // handler cannot be runned. Exclude the school from the filter.
            if (!extensionData) return false;
          }

          // if a school does not satisfy the 'extension rule' then exclude
          // this school from the results
          if (extension.handler(schoolValue, school, extensionData) === false) {
            return false;
          }
          // since there are more rules to be checked for this school we cannot
          // return true here. Rather we continue the loop of filters to check
          // if this school matches them all.
          continue;
        }
        // fall through to the next rules since there was no extension here
      }
      if (filterKey === 'naam') {
        if (!(schoolValue?.includes(filterValue))) {
          return false;
        }
      } else if (filterKey === 'onderwijsconcept') {
        // since we split these on the 'comma' we're fine matching just the substring
        if (!schoolValue?.includes(filterValue)) {
          return false;
        }
      } else if (schoolValue !== filterValue) {
        // if there is no exceptional handler for the filter, use default rule
        return false;
      }
    } /* END-OF-LOOP */

    return true;


  },
};

